import "core-js/modules/es6.regexp.match.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FIBInstallAppModal',
  data: function data() {
    return {
      deferredPrompt: null,
      installPrompt: false,
      usingSafari: navigator.userAgent.match(/Version\/[\d.]+.*Safari/),
      usingSamsungInternet: navigator.userAgent.match(/SamsungBrowser/i),
      usingInstalledApp: false,
      appInstalledThroughPrompt: false
    };
  },
  created: function created() {
    var _this = this;

    this.usingInstalledApp = (navigator.standalone || window.matchMedia('(display-mode: standalone)').matches) && !this.$q.platform.is.desktop;
    this.$store.commit('app/SET_SUPPORTED_DEVICE', this.usingInstalledApp); // Check if Android & can be installed

    if (this.$q.platform.is.android) {
      window.addEventListener('beforeinstallprompt', function (e) {
        e.preventDefault();
        _this.deferredPrompt = e;
        _this.installPrompt = true;
      });
    } // Detect when opened as a PWA


    window.matchMedia('(display-mode: standalone)').addEventListener('change', function (evt) {
      if (evt.matches && !_this.$q.platform.is.desktop) {
        _this.usingInstalledApp = true;

        _this.$store.commit('app/SET_SUPPORTED_DEVICE', _this.usingInstalledApp);
      }
    });
  },
  methods: {
    installApp: function installApp() {
      var _this2 = this;

      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then(function (result) {
        if (result.outcome === 'accepted') {
          _this2.installPrompt = false;
          _this2.appInstalledThroughPrompt = true;
        }
      });
      this.deferredPrompt = null;
    },
    getInstallInstructions: function getInstallInstructions() {
      if (this.$q.platform.is.ios && this.usingSafari) {
        return [{
          text: this.$t('appInfo.install.iosPressShareButton'),
          img: require('@/assets/pwa-install/ios-toolbar.jpg'),
          alt: 'IOS Safari toolbar'
        }, {
          text: this.$t('appInfo.install.iosPressAddToHomescreen'),
          img: require('@/assets/pwa-install/ios-share-to.jpg'),
          alt: 'IOS Safari share menu'
        }];
      } else if (this.usingSamsungInternet) {
        return [{
          text: this.$t('appInfo.install.pressMenuIcon'),
          img: require('@/assets/pwa-install/android-samsung-internet-toolbar.png'),
          alt: 'Samsung internet toolbar'
        }, {
          text: this.$t('appInfo.install.samsungPressAddPageTo'),
          img: require('@/assets/pwa-install/android-samsung-internet-menu.png'),
          alt: 'Samsung internet menu'
        }, {
          text: this.$t('appInfo.install.samsungPressHomeScreen'),
          img: require('@/assets/pwa-install/android-samsung-internet-install-menu.png'),
          alt: 'Samsung internet install menu'
        }];
      } else if (this.$q.platform.is.chrome) {
        return [{
          text: this.$t('appInfo.install.pressMenuIcon'),
          img: require('@/assets/pwa-install/android-chrome-toolbar.png'),
          alt: 'Android chrome toolbar'
        }, {
          text: this.$t('appInfo.install.chromePressInstallApp'),
          img: require('@/assets/pwa-install/android-chrome-install.png'),
          alt: 'Android chrome add to homescreen'
        }];
      }
    }
  }
};